import React from 'react'
import Styled from 'styled-components'
import * as utils from './../../scripts/utils'

import ComponentProps from './component-props'

class Subcomponents extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <SubcomponentsWrapper>
        <h2>Subcomponents</h2>
        <p>The following subcomponents are available for the <code>{this.props.name}</code> component.</p>

        {this.props.subcomponents.map((subcomponent, index) => {
          return (
            <div key={index}>
              <SubcomponentTitle>{`<${subcomponent.displayName}/>`}</SubcomponentTitle>
              <p dangerouslySetInnerHTML={{ __html: subcomponent.description.contents }} />
              { subcomponent.props && <ComponentProps subcomponent componentName={utils.camelToSpaced(subcomponent.displayName)} propsData={subcomponent.props} /> }
            </div>
          )
        })}
      </SubcomponentsWrapper>
    )
  }
}

export default Subcomponents

const SubcomponentTitle = Styled.h3`
  font-family: Roboto Mono,monospace;
  font-size: 21px;
  font-weight: 600;
  margin-top: 30px;
`

const SubcomponentsWrapper = Styled.div`
    > h1, > h2, > h3, > h4, > h5, > h6 {
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
        font-weight: 600;
    }

    > h1 {
        margin-bottom: 30px;
    }

    > h2 {
        font-weight: 600;
        font-size: 24px;
        margin-bottom: 20px;
        margin-top: 50px;
        letter-spacing: 0;
    }
`

